import styled, { css } from "styled-components";
import { designTokens } from "../../../ui/foundation/DesignTokens";

export const SelectContainer = styled.div`
  overflow: hidden;
`;

export const SelectForm = styled.div`
  display: flex;
  align-items: center;
  height: 2.5rem;
  width: 100%;
  border-radius: ${designTokens.radius.md};
  background-color: ${(props) => {
    if (props.error && !props.onboardingLabelStyle)
      return designTokens.colors.error[50];
    if (props.disabled) return "transparent";
    return designTokens.colors.gray[100];
  }};
  padding: 0.62rem 0;
  ${(props) =>
    props.onboardingLabelStyle
      ? css`
          margin-top: 20px;
          ${(props) =>
            props.error
              ? css`
                  border: 1px solid ${designTokens.colors.error[500]};
                `
              : css`
            border: border: none;
          `}
        `
      : css`
          margin-top: 0.5rem;
        `}
`;

export const SelectLabel = styled.label`
  font-family: ${designTokens.fonts.body};
  ${(props) =>
    props.onboardingLabelStyle
      ? css`
          font-style: normal;
          font-weight: 600;
          font-size: ${designTokens.fontSizes.base};
          line-height: 16px;
          letter-spacing: -0.249231px;
          color: ${designTokens.colors.gray[800]};
        `
      : css`
          font-size: ${designTokens.fontSizes.sm};
          opacity: 0.5;
        `}
  ${(props) =>
    props.addMargin &&
    css`
      display: block;
      margin-top: 40px;
      margin-bottom: 20px;
    `}
`;

export const SelectIcon = styled.img`
  margin-left: 1rem;
`;

export const SelectValue = styled.select`
  width: 320px;
  font-family: ${designTokens.fonts.heading};
  font-size: ${designTokens.fontSizes.base};
  background: none;
  border: none;
  margin-left: 1rem;
  flex-grow: 2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:focus {
    outline: none;
  }

  &,
  & option {
    color: ${designTokens.colors.gray[900]};
  }

  &:invalid,
  & option[value=""] {
    opacity: 0.2;
  }

  ${(props) =>
    props.disabled &&
    css`
      appearance: none;
    `};
`;

export const SelectError = styled.div`
  font-size: ${designTokens.fontSizes.base};
  color: ${designTokens.colors.error[500]};
`;

export const InputError = styled.div`
  ${(props) =>
    props.onboardingLabelStyle
      ? css`
          font-family: ${designTokens.fonts.body};
          font-style: normal;
          font-weight: 600;
          font-size: ${designTokens.fontSizes.xs};
          line-height: 20px;
          letter-spacing: -0.257238px;
          color: ${designTokens.colors.error[500]};
        `
      : css`
          font-size: ${designTokens.fontSizes.base};
          color: ${designTokens.colors.error[500]};
        `}
`;

export const OnboardingStyleError = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
`;

export const OnboardingErrorIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
